import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { LoginComponent } from "./login/login.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { JhaPasswordStrengthMeterModule } from "@jkhy/responsive-ui-angular/jha-password-strength-meter";
import { SymbolRulesComponent } from "./symbol-rules/symbol-rules.component";

@NgModule({
  declarations: [
    LoginComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent,
    SymbolRulesComponent,
  ],
  imports: [SharedModule, JhaPasswordStrengthMeterModule],
  exports: [SymbolRulesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuthenticationModule {}
